<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'register-step-1-content'">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar page-title="Registrasi WA Autosender" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-t-16 vh-100 d-grid-12">
                    <div class="p-x-20 grid-cspan-12" style="min-height: 50vh ;">
                        <SOStep :step="1" :total="3" />
                        <p class="f-16 f-c-black f-regular">
                            Silakan isi informasi mengenai nomor yang akan Anda gunakan.
                        </p>
                        <div class="m-d-16">
                            <SOInputTelp
                                id="input-wa"
                                title="Nomor Whatsapp"
                                :required="true"
                                countryCode="62"
                                placeholder="8123456789"
                                :value="getNotelp"
                                @input="onInput($event, 'nomor')"
                                @country-code="onInput($event, 'country_code')"
                            />
                            <ErrorMessage class="error" label="Nomor Whatsapp" :validation="$v.registered.nomor" />
                        </div>
                        <div class="m-d-16">
                            <SOInputRegular
                                id="nama-perangkat"
                                title="Nama perangkat"
                                :required="true"
                                placeholder="Nama perangkat..."
                                autocomplete="off"
                                :value="getPerangkatName"
                                @input="onInput($event, 'nama')"
                            />
                            <ErrorMessage class="error" label="Nama perangkat" :validation="$v.registered.nama" />
                        </div>
                    </div>
                    <div class="p-x-20 grid-cspan-12">
                        <SOButton
                            :primary="true"
                            :full="true"
                            :text="'Berikutnya'"
                            :id="`next-register`"
                            @action="nextStep"
                        />
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

import SOStep from "@/so-components/global/ui/SOStep.vue";
import SOInputTelp from "@/so-components/global/input/SOInputTelp.vue";
import SOInputRegular from "@/so-components/global/input/SOInputRegular.vue";
import ErrorMessage from "@/component-items/ErrorMessage";

import { minLength, required, maxLength } from "vuelidate/lib/validators";

import { moduleName } from "../store/state";

export default {
    name: "RegisterStep1",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOButton,
        SOStep,
        SOInputTelp,
        SOInputRegular,
        ErrorMessage,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.init();
            if (from.name === "wa_autosender.daftar_perangkat") {
                vm.setBackLink(from.name);
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== "wa_autosender.daftar_perangkat") {
            this.resetListPerangkat();
        }
        next();
    },
    data() {
        return {
            backLink: "wa_autosender.welcome_page",
        };
    },
    validations: {
        registered: {
            nomor: {
                required,
                minLength: minLength(8),
            },
            nama: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(100),
            },
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            registered: "registered",
        }),
        getNotelp() {
            return this.registered.nomor;
        },
        getPerangkatName() {
            return this.registered.nama;
        },
    },
    methods: {
        ...mapActions({
            setRegistered: `${moduleName}/setRegistered`,
            setVoucher: `${moduleName}/setVoucher`,
            resetListPerangkat: `${moduleName}/resetListPerangkat`,
        }),
        init() {
            this.setVoucher({});
            this.smartTrackingView("add_perangkat_whatsapp_step1");

        },
        back() {
            this.$router.push({ name: this.backLink });
        },
        onInput(val, key) {
            this.setRegistered({ key, val });
        },
        isValid() {
            let { nomor, nama } = this.$v.registered;
            nomor.$touch();
            nama.$touch();

            return nomor.$invalid || nama.$invalid;
        },
        nextStep() {
            if (this.isValid()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            this.$router.push({ name: "wa_autosender.register.step2" });
            this.smartTrackingClick("add_perangkat_whatsapp_step2");

        },
        setBackLink(val) {
            this.backLink = val;
        },
    },
};
</script>
